import { LiveApi } from 'live/lib/api'
import ExtensionService from 'live/services/extension'
import i18n from 'live/services/i18n'
import Router from 'live/services/router'

import pt_br from './i18n/pt_br'
import en_us from './i18n/en_us'

import Packages from './components/Packages'
import PackagePage from './components/PackagePage'
import VersionInfo from './components/VersionInfo'

const isLoggedIn = Object.keys(Live.currentUser).length !== 0

const locale = Live.settings?.locale ?? 'pt_br'
const localeFiles = { pt_br, en_us }
i18n.add(localeFiles[locale])

if (isLoggedIn) {
    try {
        Router.route('packages', Packages, 'packages')
        Router.route('packages/{id}', PackagePage, 'package')
        ExtensionService.addAdminMenu({
            name: i18n('Packages'),
            url: '#/packages',
            alias: 'packages',
            ico: 'fas fa-box-full',
            position: 'first-block',
            addRoute: false,
            routeUrl: null,
            component: null
        })

        LiveApi.Extension.admin?.platformExtensions?.afterTitle?.register(VersionInfo)
        LiveApi.Extension.formHeader?.afterTitle?.register(VersionInfo)
        LiveApi.Extension.dashboard?.afterTitle?.register(VersionInfo)
    } catch (error) {
        console.error(error)
    }
}
